import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { LoaderSize } from '../../enums';
import styles from './Loader.module.scss';
const Loader = ({ children, className, loaderSize = LoaderSize.Small, ...restProps }) => {
    return (_jsxs("div", { className: classNames('d-flex justify-content-center align-items-center w-100', className, { [styles.large]: loaderSize === LoaderSize.Large }), ...restProps, children: [_jsx("div", { className: classNames(styles.bounce, styles.bounce1) }), _jsx("div", { className: classNames(styles.bounce, styles.bounce2) }), _jsx("div", { className: classNames(styles.bounce, styles.bounce3) })] }));
};
export { Loader };
